import athenaConfig from '../../../config';
import { getLocalizedString } from '../../../utils/i18n-utils';
import PasswordResetBaseCustomizer, { PasswordRequirementsSelector } from '../base';
const { oieEnabled } = athenaConfig;

export default abstract class PasswordResetOieBaseCustomizer<T> extends PasswordResetBaseCustomizer<T> {
  primaryButtonLabel = getLocalizedString('save.and.continue');
  async shouldCustomize() {
    return (await super.shouldCustomize()) && oieEnabled;
  }

  protected getPasswordRequirementsSelector(): PasswordRequirementsSelector {
    return {
      containerSelector: '[data-se="password-authenticator--rules"]',
      headerSelector: '.password-authenticator--heading',
      itemListSelector: '.password-authenticator--list',
    };
  }

  protected abstract onPasswordReset(): void;

  protected abstract forgifyPasswordRequirements(): void;
}
